export const pathnameEndsWith = (pathname: string, match: string) =>
  pathname.endsWith(`/${match}`) || pathname.endsWith(`/${match}/`)

export const setOrDeleteSearchParams = (
  searchParams: URLSearchParams,
  items: Record<string, string[] | string | null | undefined>
) => {
  const params = new URLSearchParams(searchParams)
  Object.entries(items).forEach(([key, values]) => {
    if (Array.isArray(values)) {
      params.delete(key)
      values.forEach((value) => params.append(key, value))
    } else if (!values) {
      params.delete(key)
    } else {
      params.set(key, values)
    }
  })
  return params
}
